import * as React from 'react';

export const GlobalContext = React.createContext({
  openModal: null,
  closeModal: null,
});
